module.exports = __webpack_public_path__ + "static/media/mob-paintathon-list-pg01.de4f5b3b.png";